/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {IntermodalRoutingParams} from './IntermodalRoutingParams';
import {MetricParams} from './MetricParams';
import {RoutingParams} from './RoutingParams';
import {TransportUi} from './TransportUi';

/**
 * The TransportSimple model module.
 * @module model/TransportSimple
 * @version 0.0.2
 */
export class TransportSimple {
  /**
   * Constructs a new <code>TransportSimple</code>.
   * @alias module:model/TransportSimple
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TransportSimple</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TransportSimple} obj Optional instance to populate.
   * @return {module:model/TransportSimple} The populated <code>TransportSimple</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TransportSimple();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('transportType'))
        obj.transportType = ApiClient.convertToType(data['transportType'], 'String');
      if (data.hasOwnProperty('ui'))
        obj.ui = TransportUi.constructFromObject(data['ui']);
      if (data.hasOwnProperty('routingParams'))
        obj.routingParams = RoutingParams.constructFromObject(data['routingParams']);
      if (data.hasOwnProperty('intermodalRoutingParams'))
        obj.intermodalRoutingParams = IntermodalRoutingParams.constructFromObject(data['intermodalRoutingParams']);
      if (data.hasOwnProperty('metricParams'))
        obj.metricParams = MetricParams.constructFromObject(data['metricParams']);
      if (data.hasOwnProperty('isIntermodal'))
        obj.isIntermodal = ApiClient.convertToType(data['isIntermodal'], 'Boolean');
      if (data.hasOwnProperty('vehicleType'))
        obj.vehicleType = ApiClient.convertToType(data['vehicleType'], 'String');
    }
    return obj;
  }
}

/**
 * unique id of the vehicle like carsharing_regiomboil, bicycle, car, pedelec, e-scooter
 * @member {String} id
 */
TransportSimple.prototype.id = undefined;

/**
 * type of the composition of the transportType like rideAndBikesharing for oepv + bikesharing
 * @member {String} transportType
 */
TransportSimple.prototype.transportType = undefined;

/**
 * @member {module:model/TransportUi} ui
 */
TransportSimple.prototype.ui = undefined;

/**
 * @member {module:model/RoutingParams} routingParams
 */
TransportSimple.prototype.routingParams = undefined;

/**
 * @member {module:model/IntermodalRoutingParams} intermodalRoutingParams
 */
TransportSimple.prototype.intermodalRoutingParams = undefined;

/**
 * @member {module:model/MetricParams} metricParams
 */
TransportSimple.prototype.metricParams = undefined;

/**
 * @member {Boolean} isIntermodal
 */
TransportSimple.prototype.isIntermodal = undefined;

/**
 * 'public' (like train or bus) or 'individual' (like car or bicycle possible 
 * @member {String} vehicleType
 */
TransportSimple.prototype.vehicleType = undefined;

